export const environment = {
  production: false,
  defaultauth: 'fackbackend',
  firebaseConfig: { apiKey: '', authDomain: '', databaseURL: '', projectId: '', storageBucket: '', messagingSenderId: '', appId: '', measurementId: '' },
  
  apiUrl: "https://eyassur-oauthserver.dev.dokploy.eyone.net/api/rest/v1",
  apiAuth: "https://eyassur-oauthserver.dev.dokploy.eyone.net",
  baseUrl: "https://eyassur-oauthserver.dev.dokploy.eyone.net/api/rest/v1",

  REMOTE_CONTRACTS_URL: 'https://contracts-app.dev.dokploy.eyone.net/remoteEntry.js',
  REMOTE_USERS_URL: 'https://users-app.dev.dokploy.eyone.net/remoteEntry.js',
  REMOTE_PRODUCTS_URL: 'https://products-app.dev.dokploy.eyone.net/remoteEntry.js',
  REMOTE_FINANCES_URL: 'https://finances-app.dev.dokploy.eyone.net/remoteEntry.js'
};